import catalogData from "./generated/catalog.json" with { type: "json" };

import type { OriginalCatalog } from "./types";

export const originalCatalog = catalogData as OriginalCatalog;
export type {
  OriginalBackground,
  OriginalCatalog,
  OriginalFont,
  OriginalObject,
  OriginalRoom,
  OriginalRoomInstance,
  OriginalSound,
  OriginalSprite,
  OriginalSpriteFrame
} from "./types";
